import { render, staticRenderFns } from "./Auditorium.vue?vue&type=template&id=c827c9de"
import script from "./Auditorium.vue?vue&type=script&lang=js"
export * from "./Auditorium.vue?vue&type=script&lang=js"
import style0 from "./Auditorium.vue?vue&type=style&index=0&id=c827c9de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports